export const useModal = (setVisible: (isVisible: boolean) => void) => {
    return [
        () => {
            setVisible(true);
        },
        () => {
            setVisible(false);
        },
    ];
};
